import { call, put } from 'redux-saga/effects';
import importer from "common/importer";
const PublicContentActions = importer("Stores/PublicContent/Actions");
import { getMenu } from "@takedapdt/biolife-cms-kit";
import i18next from 'i18next';

export default function* main({menuType}) {
  try {
    // This line transforms a kebab-case string into camelCase and assigns it to the 'type' variable
    let type = menuType?.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());

    yield put(PublicContentActions.drupalMenuFetchLoading(type));
    const menu = yield call(getMenu, menuType, i18next.language);
    yield put(PublicContentActions.drupalMenuFetchSuccess(menu, type));
  } catch (error) {
    yield put(PublicContentActions.drupalMenuFetchFailure(error, type));
  }
}
